// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3365":"e18481507cee03ac","9758":"8f760722c446ef33"}[chunkId] + ".css";
};